import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { WaitlistsWidget } from './WaitlistsWidget'

class HoldstyringWaitlistsElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return WaitlistsWidget
  }
}

if (!customElements.get('holdstyring-waitlists')) {
  customElements.define('holdstyring-waitlists', HoldstyringWaitlistsElement)
}

export { HoldstyringWaitlistsElement }
